const API_BASE_URL = "https://du-an-trac-nghiem.onrender.com"; 

export default API_BASE_URL;